(function () {
  var ROOT_SELECTOR = '.main-product-section .main-product__info-container, .main-product-section .product__info-container';
  var WIDGET_CLASS = 'comfort-pdp-intel';
  var SALES_COUNTER_CLASS = 'comfort-sales-counter';
  var SALES_COUNTER_PATTERN = /BOUGHT\s+IN\s+PAST\s+MONTH/i;
  var US_WINDOW = [8, 18];
  var INTL_WINDOW = [10, 23];
  var salesCounterObserver = null;

  function getCountryData() {
    var data = window.EmbroycePdpData || {};
    var shopifyCountry = window.Shopify && window.Shopify.country;
    var code = String(shopifyCountry || data.countryCode || '').toUpperCase();

    if (!code && window.Intl && Intl.Locale && navigator.language) {
      try {
        code = String(new Intl.Locale(navigator.language).region || '').toUpperCase();
      } catch (error) {
        code = '';
      }
    }

    if (!code) {
      code = 'US';
    }

    var name = data.countryName;
    if (window.Intl && Intl.DisplayNames) {
      try {
        name = new Intl.DisplayNames(['en'], { type: 'region' }).of(code) || name;
      } catch (error) {
        name = name || 'your country';
      }
    }

    return {
      code: code,
      name: name || (code === 'US' ? 'United States' : 'your country'),
      flag: countryCodeToFlag(code)
    };
  }

  function countryCodeToFlag(code) {
    if (!/^[A-Z]{2}$/.test(code)) {
      return '\uD83C\uDF10';
    }

    return code
      .split('')
      .map(function (letter) {
        return String.fromCodePoint(letter.charCodeAt(0) + 127397);
      })
      .join('');
  }

  function addDays(date, days) {
    var copy = new Date(date.getTime());
    copy.setDate(copy.getDate() + days);
    return copy;
  }

  function formatDateRange(startDate, endDate) {
    var monthFormatter = new Intl.DateTimeFormat('en-US', { month: 'short' });
    var startMonth = monthFormatter.format(startDate);
    var endMonth = monthFormatter.format(endDate);
    var startDay = startDate.getDate();
    var endDay = endDate.getDate();

    if (startMonth === endMonth) {
      return startMonth + ' ' + startDay + '-' + endDay;
    }

    return startMonth + ' ' + startDay + '-' + endMonth + ' ' + endDay;
  }

  function getDeliveryRange(countryCode) {
    var windowDays = countryCode === 'US' ? US_WINDOW : INTL_WINDOW;
    var today = new Date();
    return formatDateRange(addDays(today, windowDays[0]), addDays(today, windowDays[1]));
  }

  function createIcon(name) {
    var icon = document.createElement('span');
    icon.className = 'material-symbols-outlined comfort-pdp-intel__material-icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = name;
    return icon;
  }

  function createWidget() {
    var country = getCountryData();
    var deliveryRange = getDeliveryRange(country.code);

    var wrapper = document.createElement('div');
    wrapper.className = WIDGET_CLASS;
    wrapper.setAttribute('aria-label', 'Delivery estimate');

    var deliveryDetails = document.createElement('details');
    deliveryDetails.className = 'comfort-pdp-intel__row comfort-pdp-intel__row--delivery';

    var summary = document.createElement('summary');
    var deliverLine = document.createElement('span');
    deliverLine.className = 'comfort-pdp-intel__delivery-main';

    var flag = document.createElement('span');
    flag.className = 'comfort-pdp-intel__flag';
    flag.setAttribute('aria-hidden', 'true');
    flag.textContent = country.flag;

    var deliverCopy = document.createElement('span');
    deliverCopy.append('Deliver to ');
    var countryName = document.createElement('strong');
    countryName.textContent = country.name;
    deliverCopy.append(countryName);
    deliverLine.append(flag, deliverCopy);

    var chevron = document.createElement('span');
    chevron.className = 'comfort-pdp-intel__chevron';
    chevron.setAttribute('aria-hidden', 'true');
    chevron.textContent = 'expand_more';
    chevron.classList.add('material-symbols-outlined');

    var dateLine = document.createElement('span');
    dateLine.className = 'comfort-pdp-intel__delivery-date';
    dateLine.append(createIcon('local_shipping'));
    dateLine.append('Get it by: ');
    var dateStrong = document.createElement('strong');
    dateStrong.textContent = deliveryRange;
    dateLine.append(dateStrong);

    summary.append(deliverLine, chevron, dateLine);

    var detail = document.createElement('div');
    detail.className = 'comfort-pdp-intel__detail';
    detail.textContent = country.code === 'US'
      ? 'Estimate includes 3-5 production days and 5-13 shipping days.'
      : 'International estimate includes 3-5 production days and longer overseas transit.';

    deliveryDetails.append(summary, detail);
    wrapper.append(deliveryDetails);

    return wrapper;
  }

  function insertWidget() {
    var info = document.querySelector(ROOT_SELECTOR);
    if (!info || info.querySelector('.' + WIDGET_CLASS)) {
      return;
    }

    var widget = createWidget();
    var anchor = info.querySelector('.product-page-price, .price');

    if (anchor) {
      anchor.insertAdjacentElement('beforebegin', widget);
      return;
    }

    var title = info.querySelector('.product__title');
    if (title) {
      title.insertAdjacentElement('afterend', widget);
      return;
    }

    info.prepend(widget);
  }

  function highlightSalesCounter() {
    var info = document.querySelector(ROOT_SELECTOR);
    if (!info || info.querySelector('.' + SALES_COUNTER_CLASS)) {
      return false;
    }

    var walker = document.createTreeWalker(
      info,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function (node) {
          return SALES_COUNTER_PATTERN.test(node.nodeValue)
            ? NodeFilter.FILTER_ACCEPT
            : NodeFilter.FILTER_REJECT;
        }
      }
    );
    var match = walker.nextNode();

    if (!match || !match.parentElement) {
      return false;
    }

    var current = match.parentElement;
    var candidate = null;
    while (current && current !== info) {
      var text = current.textContent.trim();
      if (SALES_COUNTER_PATTERN.test(text) && text.length <= 140) {
        candidate = current;
      }
      current = current.parentElement;
    }

    if (!candidate) {
      return false;
    }

    candidate.classList.add(SALES_COUNTER_CLASS);
    return true;
  }

  function observeSalesCounter() {
    var info = document.querySelector(ROOT_SELECTOR);
    if (!info || salesCounterObserver || highlightSalesCounter()) {
      return;
    }

    salesCounterObserver = new MutationObserver(function () {
      if (highlightSalesCounter()) {
        salesCounterObserver.disconnect();
        salesCounterObserver = null;
      }
    });
    salesCounterObserver.observe(info, {
      childList: true,
      characterData: true,
      subtree: true
    });

    window.setTimeout(function () {
      if (salesCounterObserver) {
        salesCounterObserver.disconnect();
        salesCounterObserver = null;
      }
    }, 8000);
  }

  function runProductEnhancements() {
    insertWidget();
    highlightSalesCounter();
    observeSalesCounter();
    window.setTimeout(highlightSalesCounter, 600);
    window.setTimeout(highlightSalesCounter, 1800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runProductEnhancements);
  } else {
    runProductEnhancements();
  }

  document.addEventListener('shopify:section:load', runProductEnhancements);
})();
